import { ContainerComponent, wrap } from 'AppReact';
import { DownCaretSvg, ListColsSvg } from 'components/icons';
import { BodyWrapper } from './wrappers';
import React from 'react';
import { CategoryRow, SearchInput } from './molecules';
import {
  RelativeWrapper, FlexCenterWrapper, Mr2, Mx8, CustomBorderWrapper,
  Mt3, BorderBottomWrapper, Px6, CursorPointerWrapper,
  FlexCenterBetweenWrapper, Px4, Py3, DropdownContentWrapper,
} from 'wrappers';
import { Icon, SecondaryTextSm, PrimaryTextXs, SecondaryTextXs300 } from 'atoms';
import internalState from './internalState';
import { TextButton } from 'molecules';
import controller from './controller';

const containerRef = React.createRef();

export const definition = {
  name: 'CategoryInput',
  controller: controller,
  initialProps: ({ classifiedCategories, subcategories, selectedCategoryId, isRequired }) => ({ classifiedCategories, subcategories, selectedCategoryId, isRequired }),
  props: internalState,
  elements: [
    {
      wrapper: CursorPointerWrapper,
      name: 'Selector',
      bindings: ({ isOpen }) => ({ isOpen, containerRef }),
      isButton: true,
      elements: [
        {
          wrapper: CustomBorderWrapper,
          name: 'BorderWrapper',
          displayState: ({ isRequired, selectedCategoryId }) => ({ border: isRequired && !selectedCategoryId ? '1px solid red' : '', borderRadius: '8px', padding: isRequired && !selectedCategoryId ? '4px' : '', }),
          elements: [
            {
              wrapper: FlexCenterWrapper,
              name: 'Wrapper',
              elements: [
                {
                  component: wrap(SecondaryTextXs300, Mr2),
                  name: 'CategoryName',
                  displayValue: ({ selectedCategoryId, subcategories }) => subcategories.find(c => c.id === selectedCategoryId)?.name?.toUpperCase() ?? 'Category'
                },
                {
                  component: Icon,
                  name: 'Icon',
                  displayValue: ({ }) => DownCaretSvg({ color: '#B1B1B1', width: 6, height: 6 })
                }
              ]
            }
          ]
        }
      ]
    },
    {
      wrapper: BodyWrapper,
      name: 'Body',
      ref: containerRef,
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          component: SearchInput,
          renderIf: ({ displayAdditionalCategories }) => displayAdditionalCategories,
          name: 'SearchInput',
          bindings: ({ searchValue }) => ({ value: searchValue, placeholder: 'Search' })
        },
        {
          name: 'SelectedCategoryRow',
          isButton: true,
          bindings: ({ }) => ({}),
          wrapper: wrap(wrap(wrap(FlexCenterBetweenWrapper, Py3), BorderBottomWrapper), Px4),
          renderIf: ({ displayAdditionalCategories, selectedCategoryId }) => !displayAdditionalCategories && selectedCategoryId,
          elements: [
            {
              wrapper: FlexCenterWrapper,
              name: 'LeftSide',
              elements: [
                {
                  component: wrap(Icon, Mr2),
                  name: 'Icon',
                  displayValue: () => ListColsSvg({ selected: true, width: "13.33", height: "14" }),
                },
                {
                  component: SecondaryTextSm,
                  name: 'CategoryName',
                  displayValue: ({ selectedCategoryId, subcategories }) => {
                    let category = subcategories.find(s => s.id === selectedCategoryId);
                    return category.name;
                  }
                },
              ]
            },
            {
              wrapper: FlexCenterWrapper,
              name: 'RightSide',
              elements: [
                {
                  component: wrap(PrimaryTextXs, Mr2),
                  name: 'ConfidenceDisplay',
                  renderIf: ({ selectedCategoryId, classifiedCategories }) => !!classifiedCategories.find(c => c.id === selectedCategoryId),
                  displayValue: ({ selectedCategoryId, classifiedCategories }) => {
                    let category = classifiedCategories.find(c => c.id === selectedCategoryId);
                    return `${Math.round(category.classification * 100)}% Confidence Level`;
                  }
                },
                {
                  component: Icon,
                  name: 'DownCaret',
                  displayValue: () => DownCaretSvg({}),
                }
              ]
            }
          ]
        },
        {
          component: CategoryRow,
          name: 'ClassifiedCategoryRow',
          isListOf: 'classifiedCategories',
          renderIf: ({ classifiedCategory, searchValue }) => (new RegExp(searchValue, 'i')).test(classifiedCategory.name),
          bindings: ({ classifiedCategory }) => ({ category: classifiedCategory }),
        },
        {
          component: wrap(wrap(TextButton, Mx8), Mt3),
          name: "AdditionalCategoriesButton",
          renderIf: ({ displayAdditionalCategories }) => !displayAdditionalCategories,
          bindings: ({ }) => ({ title: 'Additional Categories' }),
        },
        {
          component: wrap(BorderBottomWrapper, Px6),
          name: 'BorderBottomDiv',
          renderIf: ({ displayAdditionalCategories }) => displayAdditionalCategories,
          displayValue: ({ }) => '',
        },
        {
          wrapper: DropdownContentWrapper,
          name: 'Categories',
          renderIf: ({ displayAdditionalCategories, classifiedCategories }) => displayAdditionalCategories || classifiedCategories.length === 0,
          elements: [
            {
              component: CategoryRow,
              name: 'CategoryRow',
              isListOf: { subcategory: ({ subcategories }) => subcategories.sort((a, b) => a.name.localeCompare(b.name)) },
              renderIf: ({ subcategory, searchValue }) => (new RegExp(searchValue, 'i')).test(subcategory.name),
              bindings: ({ subcategory }) => ({ category: subcategory }),
            },
          ]
        }
      ]
    }
  ]
};

export default wrap(ContainerComponent(definition), RelativeWrapper);